import axios from 'axios';
const BASE = 'https://fitnesstrac-kr.herokuapp.com/api';



async function SignUp(username, password){
    
    try {
      const {data} = await axios.post(`${BASE}/users/register`, {
        username : username,
        password : password
      });
      
      
      return data
    } catch (error) {
      console.error(error);
    } 
}

export default SignUp
